import type { ResultOf } from "@graphql-typed-document-node/core";
import type { JSX } from "react";
import styled from "styled-components";
import { useQuery } from "urql";
import Loader from "../../../shared/components/Loader";
import t from "../../../shared/translations";
import ShowError from "../../components/ShowError";
import { graphql } from "../../gql";
import { OList, PaddedLeft } from "../stylings";
import TeamScanBox from "./TeamScanBox";

const teamScansQuery = graphql(`
    query TeamScanListQuery {
        teamScanList {
            id
            status
            reportDatetime
            progress
            myLink
            submittedTaskVariant {
                id
                submittedTask {
                    id
                    learningPathItem {
                        id
                        learningPath {
                            id
                            pathname
                        }
                    }
                }
            }
        }
    }
`);

export type ITeamScan = ResultOf<typeof teamScansQuery>["teamScanList"][number];

const Row = styled.div`
    display: grid;
    gap: 1rem;
    align-items: start;
    grid-template-columns: 1fr;
    @media (min-width: 700px) {
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
    }
`;

const TeamScansCol = styled.div`
    display: grid;
    justify-items: center;
    gap: 1rem;
`;

function Landing(): JSX.Element {
    const [result] = useQuery({
        query: teamScansQuery,
    });

    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }

    const showIntro = result.data.teamScanList.length === 1 && result.data.teamScanList[0].status === "setup-survey";

    return (
        <>
            <h1>{t("player.team-scan-landing.heading")}</h1>
            <Row>
                {showIntro && (
                    <PaddedLeft>
                        <p>{t("player.team-scan-landing.info-process-steps")}</p>
                        <OList>
                            <li>{t("player.team-scan-landing.info-process-step-1")}</li>
                            <li>{t("player.team-scan-landing.info-process-step-2")}</li>
                            <li>{t("player.team-scan-landing.info-process-step-3")}</li>
                        </OList>
                    </PaddedLeft>
                )}
                <TeamScansCol>
                    {result.data.teamScanList.map((tq) => (
                        <TeamScanBox key={tq.id} teamScan={tq} />
                    ))}
                </TeamScansCol>
            </Row>
        </>
    );
}

export default Landing;
